/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AtoN,
  AtoNDefinition,
  GetAtoNTypes200Response,
  GetAtoNs200Response,
  UserGroupUid,
} from '../models';
import {
    AtoNFromJSON,
    AtoNToJSON,
    AtoNDefinitionFromJSON,
    AtoNDefinitionToJSON,
    GetAtoNTypes200ResponseFromJSON,
    GetAtoNTypes200ResponseToJSON,
    GetAtoNs200ResponseFromJSON,
    GetAtoNs200ResponseToJSON,
    UserGroupUidFromJSON,
    UserGroupUidToJSON,
} from '../models';

export interface AddAtoNRequest {
    atoN?: AtoN;
}

export interface DeleteAtoNRequest {
    uuid: string;
}

export interface GetAtoNRequest {
    uuid: string;
}

export interface UpdateAtoNRequest {
    uuid: string;
    atoN?: AtoN;
}

/**
 * 
 */
export class AtonApi extends runtime.BaseAPI {

    /**
     * Create AtoN
     * Create AtoN
     */
    async addAtoNRaw(requestParameters: AddAtoNRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGroupUid>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/aton`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AtoNToJSON(requestParameters.atoN),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserGroupUidFromJSON(jsonValue));
    }

    /**
     * Create AtoN
     * Create AtoN
     */
    async addAtoN(requestParameters: AddAtoNRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGroupUid> {
        const response = await this.addAtoNRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a aton
     * Delete a aton
     */
    async deleteAtoNRaw(requestParameters: DeleteAtoNRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.uuid === null || requestParameters.uuid === undefined) {
            throw new runtime.RequiredError('uuid','Required parameter requestParameters.uuid was null or undefined when calling deleteAtoN.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/aton/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters.uuid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a aton
     * Delete a aton
     */
    async deleteAtoN(requestParameters: DeleteAtoNRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAtoNRaw(requestParameters, initOverrides);
    }

    /**
     * Return description of AtoN with the specified uuid
     * Return description of AtoN
     */
    async getAtoNRaw(requestParameters: GetAtoNRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AtoNDefinition>> {
        if (requestParameters.uuid === null || requestParameters.uuid === undefined) {
            throw new runtime.RequiredError('uuid','Required parameter requestParameters.uuid was null or undefined when calling getAtoN.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/aton/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters.uuid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AtoNDefinitionFromJSON(jsonValue));
    }

    /**
     * Return description of AtoN with the specified uuid
     * Return description of AtoN
     */
    async getAtoN(requestParameters: GetAtoNRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AtoNDefinition> {
        const response = await this.getAtoNRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return name and id of all AtoN types in a list.
     * Return list of all AtoN types
     */
    async getAtoNTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAtoNTypes200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/aton/types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAtoNTypes200ResponseFromJSON(jsonValue));
    }

    /**
     * Return name and id of all AtoN types in a list.
     * Return list of all AtoN types
     */
    async getAtoNTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAtoNTypes200Response> {
        const response = await this.getAtoNTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Return configuration of all AtoNs in a list
     * Return list of all defined AtoNs
     */
    async getAtoNsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAtoNs200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/aton`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAtoNs200ResponseFromJSON(jsonValue));
    }

    /**
     * Return configuration of all AtoNs in a list
     * Return list of all defined AtoNs
     */
    async getAtoNs(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAtoNs200Response> {
        const response = await this.getAtoNsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update configuration of an AtoN
     * Update configuration of an AtoN
     */
    async updateAtoNRaw(requestParameters: UpdateAtoNRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.uuid === null || requestParameters.uuid === undefined) {
            throw new runtime.RequiredError('uuid','Required parameter requestParameters.uuid was null or undefined when calling updateAtoN.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/aton/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters.uuid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AtoNToJSON(requestParameters.atoN),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update configuration of an AtoN
     * Update configuration of an AtoN
     */
    async updateAtoN(requestParameters: UpdateAtoNRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateAtoNRaw(requestParameters, initOverrides);
    }

}
